import { Button, Grid, Typography, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AddTopicPopup from './AddTopicPopup';
import { ErrorToast } from '../utils/Utils';
import { getAllDepartments, showProgress } from '../../redux/actions/DealershipActions';
import Service from '../../apis/service';
import { apiEndpoints } from '../../constants/apiEndpoints';

const useStyle = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  item: {
    width: '25vw',
    wordWrap: 'break-word',
    maxHeight: '200px',
    overflowY: 'auto',
  },
  heading: {
    textAlign: 'left',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '17px',
    fontStyle: 'normal',
    color: 'rgba(0, 0, 0, 0.4)',
    marginBottom: 0,
  },
  info: {
    wordBreak: 'break-all',
    textAlign: 'left',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '21px',
    fontStyle: 'normal',
    color: 'black',
    marginTop: '5px',
  },
  btn: {
    width: '80px',
    height: '40px',
    marginTop: '10px',
    borderRadius: '6px',
  },
});

export default function LeftsideTopic() {
  const classes = useStyle();
  const dispatch = useDispatch();
  const selectedTopicInfo = useSelector((state) => state.topicsData.selectedTopicInfo);

  const [isOpenAddTopic, setIsOpenAddTopic] = useState(false);

  const getAddDepartmentList = async () => {
    dispatch(showProgress(true));
    try {
      const res = await Service.get(apiEndpoints.GET_DEPARTMENTS);
      dispatch(getAllDepartments(res));
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  useEffect(() => {
    getAddDepartmentList();
  }, []);

  return (
    <Grid className={classes.container}>
      <Grid className={classes.item}>
        <Typography className={classes.heading}>What’s in it for me</Typography>
        {/* eslint-disable-next-line react/no-danger */}
        <div dangerouslySetInnerHTML={{ __html: selectedTopicInfo.description }} className={classes.info} />
      </Grid>
      <Grid className={classes.item}>
        <Typography className={classes.heading}>Goal</Typography>
        <Typography className={classes.info}>{selectedTopicInfo.goal}</Typography>
      </Grid>

      <Grid className={classes.item}>
        <Typography className={classes.heading}>Department</Typography>
        <Typography className={classes.info}>{selectedTopicInfo.departmentTitle}</Typography>
      </Grid>

      <Grid className={classes.item}>
        <Typography className={classes.heading}>Notes</Typography>
        {/* eslint-disable-next-line react/no-danger */}
        <div
          dangerouslySetInnerHTML={{ __html: selectedTopicInfo.notes ? selectedTopicInfo.notes : '--' }}
          className={classes.info}
        />
      </Grid>
      <Grid className={classes.item}>
        <Typography className={classes.heading}>Pre and Post Assessment</Typography>
        {!selectedTopicInfo?.initialCheckinId && !selectedTopicInfo?.finalCheckinId ? (
          <Button variant="contained" color="primary" className={classes.btn} onClick={() => setIsOpenAddTopic(true)}>
            + Add
          </Button>
        ) : (
          <Typography className={classes.info}>Configured</Typography>
        )}
      </Grid>

      {isOpenAddTopic && <AddTopicPopup isOpen={isOpenAddTopic} setIsOpen={setIsOpenAddTopic} isEdit />}
    </Grid>
  );
}
